import { useEffect } from "react";
import { useAppState } from "../../context";
import { FaqType } from "../../types";
import { fetchJson } from "../../utils";
import { FormattedText } from "../../utils/formatted-text";

export const FaqPage = () => {
    const [faqs, setFaqs] = useAppState<FaqType[]>('faqs', []);

    useEffect(() => {
        if (faqs.length > 0) return;
        fetchJson< FaqType[]>('/api/faq')
        .then(({json}) => {
            setFaqs(json);
        });
    }, []);

    return (
        <section className="section">
            <div className="inside-wrapper inside-wrapper_sm">
                <h1 className="section__title">Frequently Asked Questions (FAQ)</h1>

                <ul className="faq">
                    {faqs.map((faq, index) => (
                        <li key={index} className="faq__item js_toggle">
                            <button className="faq__trigger js_toggle_trigger">
                                <span className="faq__trigger-text"><FormattedText text={faq.question} /></span>
                            </button>
                            <div className="faq__text-holder">
                                <div className="faq__text">
                                    <FormattedText text={faq.answer} />
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>

            </div>
        </section>
    );
};

export default FaqPage;